import { navigate } from 'gatsby';
import React, { FC } from 'react';

import DashboardTask from '@ui/molecules/DashboardTask';

interface IScheduleAppointmentTaskProps extends ITaskProps {
	done: boolean;
}

const ScheduleAppointmentTask: FC<IScheduleAppointmentTaskProps> = ({
	updateTaskStatus,
	heading,
	description,
	image,
	alt,
	done,
	loading,
}) => {
	const onClick = () => {
		if (!done) navigate('/app/member/get_care');
	};

	return (
		<DashboardTask
			heading={heading}
			description={description}
			image={image}
			alt={alt}
			onClick={onClick}
			done={done}
			loading={loading}
		/>
	);
};

export default ScheduleAppointmentTask;
